"use client";

import React from "react";
import { useUniversity } from "@/university";
import { Info, CheckCircle } from "lucide-react";

interface UniversityOverlayProps {
    slug: string;
    className?: string;
}

export function UniversityOverlay({ slug, className = "" }: UniversityOverlayProps) {
    const { pack } = useUniversity();

    if (pack.id === "global") return null;

    const overlay = pack.overlays[slug];
    if (!overlay) return null;

    return (
        <div className={`my-8 p-6 bg-slate-50 dark:bg-white/5 border border-slate-100 dark:border-white/10 rounded-2xl shadow-sm ${className}`}>
            <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-indigo-50 dark:bg-indigo-500/20 rounded-xl flex items-center justify-center text-indigo-600 dark:text-indigo-400">
                    <Info className="w-5 h-5" />
                </div>
                <h3 className="text-lg font-bold text-slate-900 dark:text-white">
                    {overlay.title}
                </h3>
            </div>

            <div className="space-y-4">
                {overlay.body.map((paragraph: string, idx: number) => (
                    <p key={idx} className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed">
                        {paragraph}
                    </p>
                ))}
            </div>

            {overlay.bullets && overlay.bullets.length > 0 && (
                <ul className="mt-4 space-y-2">
                    {overlay.bullets.map((bullet: string, idx: number) => (
                        <li key={idx} className="flex gap-3 text-sm text-slate-600 dark:text-slate-300">
                            <CheckCircle className="w-4 h-4 text-indigo-500 dark:text-indigo-400 shrink-0 mt-0.5" />
                            <span>{bullet}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
